import { useMutation } from '@tanstack/react-query';
import { patchAttachmentTypeAndLocation } from '../Services/ProcessedTimesheetService';

const usePatchAttachmentTypeAndLocation = (options = {}) =>
    useMutation(patchAttachmentTypeAndLocation, options);

export default usePatchAttachmentTypeAndLocation;
